/**
 * Custom Logo Customization
 * Logo customization UI logic: private label toggle, file upload,
 * position selection, fee calculation, MOQ validation.
 * Ported from sodalemons theme.
 */

document.addEventListener('DOMContentLoaded', function () {
  initLogoCustomization();
});

function initLogoCustomization() {
  // --- Option card selection ---
  document.querySelectorAll('.custom-logo-option-group').forEach((group) => {
    group.addEventListener('click', (e) => {
      const card = e.target.closest('.custom-logo-option-card');
      if (!card) return;

      const target = card.dataset.target;
      const value = card.dataset.value;

      // Deselect siblings
      group.querySelectorAll('.custom-logo-option-card').forEach((c) => {
        c.classList.remove('selected');
      });
      card.classList.add('selected');

      // Handle private label toggle
      if (target === 'private-label') {
        const details = document.getElementById('private-label-block');
        if (details) {
          details.open = value === 'yes';
        }
        if (value === 'no') {
          resetLogoFees();
        }
        updateCartBtnState();
      }

      // Handle first order toggle
      if (target === 'first-order') {
        updateLogoSetupFee();
      }

      updatePrintLogoFee();
    });
  });

  // --- File upload (add row) ---
  const addBtn = document.querySelector('.custom-logo-btn-add');
  if (addBtn) {
    addBtn.addEventListener('click', addLogoRow);
  }

  // --- File upload delegation (change, delete) ---
  const logoTable = document.getElementById('custom-logo-table');
  if (logoTable) {
    logoTable.addEventListener('change', (e) => {
      if (e.target.classList.contains('custom-logo-file-input')) {
        handleFileSelect(e.target);
      }
      if (e.target.classList.contains('custom-logo-size-input')) {
        delayedCalc();
      }
    });

    logoTable.addEventListener('click', (e) => {
      const delBtn = e.target.closest('.custom-logo-btn-del');
      if (delBtn) {
        delLogoRow(delBtn);
      }
      const upBtn = e.target.closest('.custom-logo-btn-up');
      if (upBtn) {
        const fileInput = upBtn.parentElement.querySelector('.custom-logo-file-input');
        if (fileInput) fileInput.click();
      }
    });
  }

  // --- Material card selection ---
  document.querySelectorAll('.custom-logo-material-group').forEach((group) => {
    group.addEventListener('click', (e) => {
      const card = e.target.closest('.custom-logo-material-card');
      if (!card) return;

      group.querySelectorAll('.custom-logo-material-card').forEach((c) => {
        c.classList.remove('selected');
      });
      card.classList.add('selected');

      updatePrintLogoFee();
    });
  });

  // --- Position tab switching ---
  document.querySelectorAll('.custom-logo-position-tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      const container = tab.closest('.custom-logo-section');
      container.querySelectorAll('.custom-logo-position-tab').forEach((t) => {
        t.classList.remove('active');
      });
      tab.classList.add('active');

      const targetId = tab.dataset.target;
      container.querySelectorAll('.custom-logo-position-content').forEach((c) => {
        c.classList.remove('active');
      });
      const targetContent = document.getElementById(targetId);
      if (targetContent) targetContent.classList.add('active');
    });
  });

  // --- Position checkbox change ---
  document.querySelectorAll('.custom-logo-position-content').forEach((content) => {
    content.addEventListener('change', (e) => {
      if (e.target.type === 'checkbox') {
        updatePrintLogoFee();
      }
    });
  });

  // --- Description input ---
  const descInput = document.querySelector('.custom-logo-desc');
  if (descInput) {
    descInput.addEventListener('input', () => {});
  }

  // Initial calculations
  updateLogoSetupFee();
  updatePrintLogoFee();
  updateCartBtnState();
  renderDiscountTable();
}

// --- Row management ---

function addLogoRow() {
  const table = document.getElementById('custom-logo-table');
  if (!table) return;

  // Find the last logo-row-header to insert after it, or just append
  const row = document.createElement('div');
  row.className = 'custom-logo-row';
  row.innerHTML = `
    <div class="custom-logo-upload-area">
      <input type="file" class="custom-logo-file-input" accept=".jpg,.jpeg,.png,.ai,.esp" hidden>
      <button type="button" class="custom-logo-btn-up">Upload</button>
      <span class="custom-logo-file-name">No file selected</span>
    </div>
    <div class="custom-logo-size-area">
      <input type="number" class="custom-logo-size-input" placeholder="Width" min="1" max="50">
      <span style="font-size:1.1rem;color:rgba(var(--color-foreground),0.5)">×</span>
      <input type="number" class="custom-logo-size-input" placeholder="Height" min="1" max="50">
      <button type="button" class="custom-logo-btn-del">Delete</button>
    </div>
  `;
  table.appendChild(row);
  updateLogoSetupFee();
  updatePrintLogoFee();
}

function delLogoRow(btn) {
  const row = btn.closest('.custom-logo-row');
  if (row) {
    row.remove();
    updateLogoSetupFee();
    updatePrintLogoFee();
  }
}

function handleFileSelect(input) {
  const row = input.closest('.custom-logo-row');
  if (!row) return;
  const nameSpan = row.querySelector('.custom-logo-file-name');
  if (input.files && input.files.length > 0) {
    nameSpan.textContent = input.files[0].name;
  } else {
    nameSpan.textContent = 'No file selected';
  }
  updateLogoSetupFee();
  updatePrintLogoFee();
}

function delayedCalc() {
  // Debounced calculation for size input changes
  if (window._logoCalcTimer) clearTimeout(window._logoCalcTimer);
  window._logoCalcTimer = setTimeout(() => {
    updatePrintLogoFee();
  }, 300);
}

// --- Fee calculations ---

function isNeedLogo() {
  const selected = document.querySelector(
    '.custom-logo-option-card.selected[data-target="private-label"]'
  );
  return selected && selected.dataset.value === 'yes';
}

function isFirstLogo() {
  const selected = document.querySelector(
    '.custom-logo-option-card.selected[data-target="first-order"]'
  );
  return selected && selected.dataset.value === 'yes';
}

function getLogoFileCount() {
  const rows = document.querySelectorAll('#custom-logo-table .custom-logo-row');
  let count = 0;
  rows.forEach((row) => {
    const fileInput = row.querySelector('.custom-logo-file-input');
    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      count++;
    }
  });
  return count || 0;
}

function getLogoSizeData() {
  const rows = document.querySelectorAll('#custom-logo-table .custom-logo-row');
  const data = [];
  rows.forEach((row) => {
    const fileInput = row.querySelector('.custom-logo-file-input');
    const widthInput = row.querySelectorAll('.custom-logo-size-input')[0];
    const heightInput = row.querySelectorAll('.custom-logo-size-input')[1];
    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      data.push({
        path: fileInput.files[0],
        pathName: fileInput.files[0].name,
        width: widthInput ? widthInput.value : '',
        height: heightInput ? heightInput.value : '',
      });
    }
  });
  return data;
}

function getSelectedPositions() {
  const checked = document.querySelectorAll(
    '.custom-logo-position-content input[type="checkbox"]:checked'
  );
  return Array.from(checked).map((cb) => cb.value);
}

/**
 * Returns rich position data for each selected checkbox:
 * { name, image (URL), tabTitle }
 */
function getPositionDisplayData() {
  const checked = document.querySelectorAll(
    '.custom-logo-position-content input[type="checkbox"]:checked'
  );
  return Array.from(checked).map(function(cb) {
    var item = cb.closest('.custom-logo-position-item');
    var label = item ? item.querySelector('label') : cb.nextElementSibling;
    var img = label ? label.querySelector('img') : null;
    var contentDiv = cb.closest('.custom-logo-position-content');
    var tabTitle = '';
    if (contentDiv) {
      var contentId = contentDiv.id;
      if (contentId) {
        var tab = document.querySelector('.custom-logo-position-tab[data-target="' + contentId + '"]');
        if (tab) tabTitle = tab.textContent.trim();
      }
    }
    return {
      name: cb.value,
      image: img ? img.getAttribute('src') : '',
      tabTitle: tabTitle
    };
  });
}

function getTotalQuantity() {
  const totalEl = document.querySelector('.total-quantity');
  if (totalEl) return parseInt(totalEl.textContent) || 0;
  return 0;
}

function getSelectedMaterialPrice() {
  const selected = document.querySelector('.custom-logo-material-card.selected');
  if (selected) return parseInt(selected.dataset.price) || 0;
  return 0;
}

function updateLogoSetupFee() {
  const setupNumEl = document.querySelector('.summary-logo-setup-num');
  const setupFeeEl = document.querySelector('.summary-logo-setup-fee');

  if (!setupNumEl || !setupFeeEl) return;

  if (isFirstLogo()) {
    const fileCount = getLogoFileCount() || 1;
    setupNumEl.textContent = fileCount;
    setupFeeEl.textContent = (50 * fileCount).toFixed(2);
  } else {
    setupNumEl.textContent = '0';
    setupFeeEl.textContent = '0.00';
  }
}

function updatePrintLogoFee() {
  const plNumEl = document.querySelector('.summary-pl-num');
  const plFeeEl = document.querySelector('.summary-pl-fee');
  if (!plNumEl || !plFeeEl) return;

  if (!isNeedLogo()) {
    plNumEl.textContent = '0';
    plFeeEl.textContent = '0.00';
    return;
  }

  const fileCount = getLogoFileCount() || 1;
  const positions = getSelectedPositions();
  const positionCount = positions.length || 1;
  const totalQty = getTotalQuantity();
  const materialPrice = getSelectedMaterialPrice();

  const printQty = totalQty * positionCount * fileCount;
  const printFee = (materialPrice * totalQty * positionCount * fileCount) / 100;

  plNumEl.textContent = printQty;
  plFeeEl.textContent = printFee.toFixed(2);
}

function resetLogoFees() {
  const setupFeeEl = document.querySelector('.summary-logo-setup-fee');
  const plNumEl = document.querySelector('.summary-pl-num');
  const plFeeEl = document.querySelector('.summary-pl-fee');
  const setupNumEl = document.querySelector('.summary-logo-setup-num');

  if (setupNumEl) setupNumEl.textContent = '0';
  if (setupFeeEl) setupFeeEl.textContent = '0.00';
  if (plNumEl) plNumEl.textContent = '0';
  if (plFeeEl) plFeeEl.textContent = '0.00';
}

function updateCartBtnState() {
  const cartBtn = document.querySelector('product-form button[name="add"]');
  if (!cartBtn) return;

  const totalQty = getTotalQuantity();

  if (isNeedLogo()) {
    const customVariant = document.querySelector('custom-variant');
    const logoLimit = parseInt(
      customVariant?.getAttribute('data-logo-limit-quantity') || '0'
    );
    if (logoLimit > 0 && totalQty < logoLimit) {
      cartBtn.setAttribute('aria-disabled', 'true');
      return;
    }
  }

  if (totalQty > 0) {
    cartBtn.removeAttribute('aria-disabled');
  } else {
    cartBtn.setAttribute('aria-disabled', 'true');
  }
}

/**
 * Collect logo properties for cart items
 */
function getLogoProperties() {
  if (!isNeedLogo()) return {};

  const logoData = getLogoSizeData();
  const positions = getSelectedPositions();
  const selectedMaterialCard = document.querySelector(
    '.custom-logo-material-card.selected'
  );
  const descInput = document.querySelector('.custom-logo-desc');

  const properties = {};

  // Logo files (paths)
  logoData.forEach((item, i) => {
    if (item.path) {
      properties[`customLogo_${i}`] = item.path;
      properties[`customLogoSrcName_${i}`] = item.pathName || '';
    }
  });

  // Logo sizes
  const sizes = logoData
    .map((item) => {
      if (item.width && item.height) {
        return `${item.width}inch * ${item.height}inch`;
      }
      return null;
    })
    .filter(Boolean);
  if (sizes.length > 0) {
    properties.logoSize = sizes.join(',');
  }

  // Logo first order
  properties.logoFirst = isFirstLogo() ? 'YES' : 'NO';

  // Positions
  if (positions.length > 0) {
    properties.customPosition = positions.join(',');
  }

  // Material
  if (selectedMaterialCard) {
    properties.logoMaterialName = selectedMaterialCard.dataset.name || '';
  }

  // Description
  if (descInput && descInput.value.trim()) {
    properties.logoDesc = descInput.value.trim();
  }

  return properties;
}


function renderDiscountTable() {
  var tb = document.querySelector('.custom-logo-discount-table tbody');
  if (!tb) return;
  var price = 0;
  var vs = document.querySelector('custom-variant variant-selects [data-selected-variant]') || document.querySelector('variant-selects [data-selected-variant]');
  if (vs) { try { price = JSON.parse(vs.textContent).price; } catch(e) {} }
  if (!price) {
    var pe = document.querySelector('.price-item--regular') || document.querySelector('[id^=price-] .price');
    if (pe) { var r = pe.textContent.replace(/[^0-9.]/g, ''); price = Math.round(parseFloat(r) * 100); }
  }
  if (!price || price <= 0) { tb.innerHTML = '<tr><td colspan="3">Loading...</td></tr>'; return; }
  var lb = document.querySelector('.custom-logo-block');
  var rt = lb ? (lb.getAttribute('data-discount-tiers') || '') : '';
  rt = rt.replace(/\\n/g, '\n');
  var dl = [];
  console.log('renderDiscountTable', price);
  console.log('renderDiscountTable',lb);
  if (rt) {
    var lines = rt.split('\n');
    for (var t = 0; t < lines.length; t++) {
      var line = lines[t].trim();
      if (!line) continue;
      var parts = line.split('|');
      if (parts.length >= 2) {
        var amt = parseInt(parts[0].trim()) * 100;
        var pct = parseInt(parts[1].trim());
        if (!isNaN(amt) && !isNaN(pct)) {
          var qty = Math.ceil(amt / price);
          var rng = t === 0 ? '< ' + qty : '> ' + qty;
          dl.push([rng, pct, pct + '% OFF', amt]);
        }
      }
    }
  }
  if (dl.length === 0) { tb.innerHTML = '<tr><td colspan="3">Not configured</td></tr>'; return; }
  var h = '';
  dl.forEach(function(e) {
    var d = Number(e[1]);
    if (isNaN(d)) { h += '<tr><td>' + e[0] + '</td><td>' + e[1] + '</td><td>' + e[2] + '</td></tr>'; }
    else {
      var cp = price * (100 - d) * 0.01;
      h += '<tr><td>' + e[0] + '</td><td>$' + (cp / 100).toFixed(2) + '</td><td>' + d + '%</td></tr>';
    }
  });
  tb.innerHTML = h;
}
document.addEventListener('variant:change', function() { renderDiscountTable(); });
document.addEventListener('product-info:loaded', function() { setTimeout(renderDiscountTable, 100); });
window.updateCartBtnState = updateCartBtnState;
window.updatePrintLogoFee = updatePrintLogoFee;
window.updateLogoSetupFee = updateLogoSetupFee;
window.getLogoProperties = getLogoProperties;
window.getTotalQuantity = getTotalQuantity;
window.isNeedLogo = isNeedLogo;
window.isFirstLogo = isFirstLogo;
window.getLogoSizeData = getLogoSizeData;
window.getSelectedPositions = getSelectedPositions;
window.getLogoFileCount = getLogoFileCount;
window.getPositionDisplayData = getPositionDisplayData;

